import axios, { AxiosError } from 'axios';
import { getChannelId, isWeb } from '../storage';
import { environment } from '../environments';
import AsyncStorage from '../storage';
import { store } from '../store';
import { API_URL } from './apiMapper';
import { userLogout } from '../reducer/userSlice';
import { encryptAES, getTokens, isRefreshFalse, showNetworkLogger } from '../utils/helper';
import { getPasskeyToken } from '../utils/passkeyList';
// import { v4 as uuidv4 } from 'uuid';
import SecureLS from 'secure-ls';

import { getUUID as uuidv4 } from '../utils/getUUID';

let firebase: any;
let Braze: any;
if (!isWeb) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  firebase = require('@react-native-firebase/installations').default;
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  Braze = require('@braze/react-native-sdk').default;
}

const axiosInstance = axios.create({
  baseURL: environment.baseUrl,
});

// Initialize SecureLS for web
let secureLS: SecureLS | null = null;
if (isWeb) {
  secureLS = new SecureLS({ encodingType: 'aes' });
}

const handleLogout = () => {
  console.log('logging out from axios setup');
  store.dispatch(userLogout());
  // if (isWeb) {
  //   store.dispatch(userLogout());
  //   window.location.href = '/sign-in';
  // } else {
  //   store.dispatch(logout());
  //   AsyncStorage.clear(); // Clear all storage, not just tokens

  //   // Check if navigation is ready before using it
  //   if (navigationRef.isReady()) {
  //     navigationRef.dispatch(
  //       CommonActions.reset({
  //         index: 0,
  //         routes: [{ name: 'SignIn' }],
  //       })
  //     );
  //   }
  // }
};

const getDeviceIdforWeb = () => {
  try {
    const ls = new SecureLS({ encodingType: 'aes', isCompression: false });

    const deviceId = localStorage.getItem('deviceId');
    let storedId: string | null;

    if (deviceId) {
      try {
        storedId = ls.get('deviceId');
      } catch {
        localStorage.removeItem('deviceId');
        const newDeviceId = uuidv4();
        ls.set('deviceId', newDeviceId);
        storedId = newDeviceId;
      }
    } else {
      if (!deviceId) {
        const newDeviceId = uuidv4();
        ls.set('deviceId', newDeviceId);
        storedId = newDeviceId;
      }
    }
    if (isWeb && ls) {
      return ls.get('deviceId') || 'testing';
    }
  } catch (error) {
    console.log('failed deviceId error', error);
    return null;
  }
};

const getAccounts = async () => {
  try {
    let accountDetails: any | null = '';
    if (isWeb && secureLS) {
      accountDetails = secureLS.get('user');
    } else {
      accountDetails = await AsyncStorage.getItem('user');
    }
    console.log('accountDetails ----->', accountDetails);
    if (accountDetails) {
      const { accountId, customerId } = JSON.parse(accountDetails);
      return { accountId, customerId };
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error retrieving tokens:', error);
    return null;
  }
};

// Helper function to save tokens to storage
const saveTokens = async (tokens: any) => {
  try {
    if (isWeb && secureLS) {
      secureLS.set('tokens', JSON.stringify(tokens));
    } else {
      await AsyncStorage.setItem('tokens', JSON.stringify(tokens));
    }
  } catch (error) {
    console.error('Error saving tokens:', error);
  }
};

// Function to refresh the token
const refreshToken = async (): Promise<string | undefined | null> => {
  try {
    const tokens = await getTokens();
    const accountDetails = await getAccounts();
    const deviceId = isWeb ? getDeviceIdforWeb() : await firebase().getId();
    if (!tokens) {
      console.warn('No tokens found, logging out...');
      handleLogout();
      return null;
    }

    const { accessToken, refreshToken } = tokens;
    console.log('tokens==>', !accessToken, !refreshToken);
    if (!accessToken || !refreshToken) {
      console.warn('Missing accessToken or refreshToken, logging out...');
      handleLogout();
      return null;
    }

    // Refresh token request using query parameters
    const axiosInst = axios.create({
      baseURL: environment.baseUrl,
    });

    axiosInst.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${accessToken}`;
      config.headers['Content-Type'] = 'application/json';
      config.headers.channel = getChannelId;
      config.headers.accesstoken = accessToken;
      config.headers.refreshtoken = refreshToken;
      config.headers.deviceId = deviceId;
      config.headers.accountId = encryptAES(accountDetails?.accountId) || '';
      config.headers.customerId = encryptAES(accountDetails?.customerId) || '';
      showNetworkLogger('request', config);
      return config;
    });
    axiosInst.interceptors.response.use(
      async function (response) {
        const { config, headers } = response;
        console.log('network== config?.url', config?.url);
        console.log('network== response headers', headers);
        showNetworkLogger('response', response);
        return response;
      },
      async function (error) {
        showNetworkLogger('error', error);
        return Promise.reject(error.response.data);
      }
    );
    const response = await axiosInst.post(`${API_URL.regeneratetoken}`, {
      accountId: accountDetails?.accountId || '',
      customerId: accountDetails?.customerId || '',
      deviceId: deviceId,
      channel: getChannelId,
      accesstoken: accessToken,
      refreshtoken: refreshToken,
      flow: 'PATH_REGEN_TOKEN_API',
    });

    console.log('regeneratetoken', response);
    console.log({
      accountId: accountDetails?.accountId || '',
      customerId: accountDetails?.customerId || '',
      deviceId: deviceId,
      channel: getChannelId,
      accesstoken: accessToken,
      refreshtoken: refreshToken,
      flow: 'PATH_REGEN_TOKEN_API',
    });

    // Handle session timeout
    if (response.data?.status === '440') {
      console.warn('Session Timeout received, logging out...');
      handleLogout();
      return null;
    }

    if (response.status === 200) {
      if (response.headers?.accesstoken && response.headers?.refreshtoken) {
        let newTokens: any = {
          accessToken: response.headers?.accesstoken,
          refreshToken: response.headers?.refreshtoken,
          expiryTime: response.headers?.expirytime
            ? response.headers?.expirytime
            : Date.now() + 9.4 * 60 * 1000,
        };
        if (response.headers?.brazejwt) {
          newTokens = { ...newTokens, brazejwt: response?.headers?.brazejwt };
          try {
            console.log('Updating the Braze token', response.headers?.brazejwt);
            if (isWeb) {
              const brazeWeb = await import('@braze/web-sdk');
              brazeWeb.setSdkAuthenticationSignature(response.headers.brazejwt);
            } else if (Braze) {
              Braze.setSdkAuthenticationSignature(response.headers?.brazejwt);
            }
          } catch (e) {
            console.log('Braze new token is not set', e);
          }
        }
        console.log('saveTokens newTokens', newTokens);
        await saveTokens(newTokens);
        return newTokens.accessToken;
      } else {
        return accessToken;
      }
    }
  } catch (error) {
    console.error('Error refreshing token:', error);
    console.warn('Token refresh failed, logging out...');
    handleLogout();
    return null;
  }
};

// Request Interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    if (
      (!config?.url?.includes(API_URL.sign_in) &&
        config?.url !== API_URL.passkey_sign_in) ||
      config?.url?.includes('/v1/authenticate/user/signout')
    ) {
      const tokens = await getTokens();
      const accessToken = tokens?.accessToken;
      const expiryTime = tokens?.expiryTime;
      const currentTime = Date.now();

      if (config.method === 'post')
        console.log('interceptors config', JSON.stringify(config));

      if (
        expiryTime - currentTime < 2 * 60 * 1000 &&
        expiryTime - currentTime > 0
      ) {
        const newAccessToken = await refreshToken();
        if (newAccessToken) {
          config.headers['Authorization'] = `Bearer ${newAccessToken}`;
        } else {
          return Promise.reject(new Error('Refresh token error'));
        }
      } else {
        if (accessToken) {
          config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
      }
      const deviceId = isWeb ? getDeviceIdforWeb() : await firebase().getId();
      config.headers.deviceId = deviceId;
      const accountDetails = await getAccounts();
      config.headers.accountId = encryptAES(accountDetails?.accountId) || '';
      config.headers.customerId = encryptAES(accountDetails?.customerId) || '';
    }
    config.headers.channel = getChannelId;
    config.headers['Content-Type'] = 'application/json';
    if (config?.url?.includes('/transactions?limit')) {
      // For transactions endpoint, only set to 'true' if it's a pull-to-refresh
      config.headers.isRefresh = (config as any)?.isTransactionRefresh
        ? 'true'
        : 'false';
    } else if (isRefreshFalse(config.url)) {
      // only for selected URL you set to 'false'
      config.headers.isRefresh = 'false';
    } else {
      // For all other endpoints, always set to 'true'
      config.headers.isRefresh = 'true';
    }
    showNetworkLogger('request', config);
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    if (error.response.status === 440 || error.response.status === 403) {
      handleLogout();
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  async function (response) {
    const { config, headers } = response;
    console.log('network== config?.url', config?.url);
    console.log('network== response headers', headers);
    showNetworkLogger('response', response);
    if (
      config?.url === API_URL.sign_in ||
      config?.url === API_URL.passkey_sign_in ||
      config?.url === API_URL.validate_passcode
    ) {
      if (config?.url === API_URL.passkey_sign_in) {
        console.log('[v2-passkey] response headers:', JSON.stringify(headers));
        console.log('[v2-passkey] accesstoken:', headers?.accesstoken);
        console.log('[v2-passkey] refreshtoken:', headers?.refreshtoken);
        console.log('[v2-passkey] expirytime:', headers?.expirytime);
      }
      console.log('Headers - Braze JWT >>>>>>>>>>', headers?.brazejwt);
      if (headers?.accesstoken && headers?.refreshtoken && headers.expirytime) {
        let tokens: any = {
          accessToken: headers?.accesstoken,
          refreshToken: headers?.refreshtoken,
          expiryTime: headers.expirytime,
        };
        if (headers?.brazejwt) {
          tokens = { ...tokens, brazejwt: headers?.brazejwt };
        }
        await saveTokens(tokens);
      } else {
        console.log(
          `Response Headers does not have tokens in the ${API_URL.sign_in}`
        );
      }
    }

    if (response.status === 440 || response.status === 403) {
      handleLogout();
      throw new AxiosError('Token Expired', response.status.toString());
    }

    return response;
  },
  async function (error) {
    showNetworkLogger('error', error);
    // Early exit if error doesn't have expected structure
    if (!error.response || !error.config) {
      console.error('Unexpected error structure:', error);
      return Promise.reject(error);
    }
    if (error.response.status === 500) {
      console.log('[axiosSetup] 500 error intercepted');
      console.log('[axiosSetup] error.response.data:', error.response.data);

      // Check if this is a 409 error wrapped in 500 (e.g., Ban already registered)
      if (
        error.response.data?.status === '409' ||
        error.response.data?.status === 409
      ) {
        console.log(
          '[axiosSetup] Detected 409 error wrapped in 500, preserving error details'
        );
        // Return the actual error data instead of generic UNKNOWN_ERROR
        return Promise.reject(error.response.data);
      }

      // For other 500 errors, return generic error format
      console.log('[axiosSetup] Generic 500 error, returning UNKNOWN_ERROR');
      return Promise.reject({
        statusCode: error.response.status,
        error: {
          errCode: 'UNKNOWN_ERROR',
          msg: error.response.data.message,
          statusCode: error.response.status,
        },
      });
    }
    console.log('error>>>', error.response.headers);
    if (error.response.status === 412) {
      const url = `${error.config?.baseURL ?? ''}${error.config?.url ?? ''}`;
      const passkeyToken = getPasskeyToken(error.response.headers);
      const isPasskeyOtpStepUp =
        url.includes('/v1/passkey/register') ||
        url.includes('/v1/passkey/deregister') ||
        Boolean(passkeyToken);
      if (isPasskeyOtpStepUp) {
        const data = error.response.data;
        const payload =
          data && typeof data === 'object' && !Array.isArray(data)
            ? data
            : { message: data };
        return Promise.reject({
          ...payload,
          status: payload.status ?? 412,
          statusCode: 412,
          message:
            payload.message ?? (typeof data === 'string' ? data : undefined),
          headers: error.response.headers,
          passkeyToken,
        });
      }
      const newTokens = {
        accessToken: error.response.headers?.accesstoken,
        refreshToken: error.response.headers?.refreshtoken,
        expiryTime: error.response.headers?.expirytime
          ? error.response.headers?.expirytime
          : Date.now() + 9.4 * 60 * 1000,
      };
      console.log('saveTokens TempTokens', newTokens);
      await saveTokens(newTokens);
    }
    if (error.response.status === 440 || error.response.status === 403) {
      handleLogout();
    }
    return Promise.reject(error.response.data);
  }
);

export default axiosInstance;
